import T from 'utils/T';
import ex from 'utils/ex';

export default function CaptionBox(props) {
  const {
    caption,
  } = props || {};
  return (
    <div {...ex('CaptionBox', props)}>
      <div>
        {caption}
      </div>
    </div>
  );
}
